<template>
    <div class="noticeDetail">
            <Navbar title="通知详情" :backNative="false"  />

            <div class="detail_content">
                 <div class="detail_title">
                     {{detail.title}}
                 </div>
                 <div class="time">{{detail.releaseTime}}</div>
                 <div class="richText" v-html="detail.content"></div>
            </div>
    </div>
</template>

<script>
import Navbar from "../../components/NavBar";
import http from "../../utils/http";
export default {
  data(){
      return {
        detail:{}
      }
  },
  mounted(){
      this.getDetail()
  },
  activated(){
      this.getDetail()
  },
  methods:{
      getDetail(){
          let query =this.$route.query
          http.getSysNoticeDetail({id:query.id,type:0}).then(res=>{
              console.log(res)
              this.detail=res
          })
      },
  },
  components:{
      Navbar,
  },
}
</script>

<style lang="less" scoped>
.noticeDetail{
   .detail_content{
       width: calc(100% - 32px);
       margin: 0 auto;
       .detail_title{
           font-size: 18px;
           color: #222030;
           margin-top: 12px;
       }
       .time{
           font-size: 11px;
           color: rgba(34,32,48,0.25);
           margin-top: 4px;
       }
       .richText{
           width: calc(100% - 32px);
           margin: 0 auto;
           margin-top: 20px;
             /deep/ img {
         max-width: 99%;
  }
       }
   }
}
</style>

